/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Recovery_Code_WarningInputs */



/**
* | output |
* | --- |
* | "This code is only shown once and cannot be recovered. Please save it securely." |
*
* @param {Auth_Recovery_Code_WarningInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_recovery_code_warning = /** @type {((inputs?: Auth_Recovery_Code_WarningInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Recovery_Code_WarningInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieser Code wird nur einmal angezeigt und kann nicht wiederhergestellt werden. Bitte speichere ihn sicher.")
	return /** @type {LocalizedString} */ ("This code is only shown once and cannot be recovered. Please save it securely.")
});